import { setStorage, getStorage } from '@/utils/storage'

const state = {
  inElectron: true,
  size: getStorage('smartTeachingFontSize') || 33,
  zoom: getStorage('smartTeachingFontZoom') || 1,
  // measureRateScale: {} // 评测松紧度
  measureRateScale: { 1: '1.00', 2: '1.00', 3: '1.00', 12: '1.00', 15: '1.15' }, // 评测松紧度
  // 班级答题器版本 UID_t
  classDeviceType: getStorage('classDeviceType') || '18',
  bookMaterial: {}, // 教材版本
  showExportProgress: false, // 右上角导出进度列表
  showBrushVisible: false // 是否显示画笔
}

const mutations = {
  SET_SIZE: (state, size) => {
    state.size = size
    setStorage('smartTeachingFontSize', size)
  },
  SET_ZOOM: (state, zoom) => {
    state.zoom = zoom
    setStorage('smartTeachingFontZoom', zoom)
  },
  SET_IN_ELECTRON: (state, inElectron) => {
    state.inElectron = inElectron
  },
  SET_MEASURE_RATE_SCALE: (state, measureRateScale) => {
    state.measureRateScale = measureRateScale
  },
  SET_BOOK_MATERIAL: (state, bookMaterial) => {
    state.bookMaterial = bookMaterial
  },
  SET_SHOW_EXPORT_PROGRESS: (state, bol) => {
    state.showExportProgress = bol
  },
  SET_CLASS_DEVICE_TYPE: (state, uidType) => {
    state.classDeviceType = String(uidType)
    setStorage('classDeviceType', String(uidType))
  },
  SET_SHOW_BRUSH_VISIBLE(state, visible) {
    state.showBrushVisible = visible
  }
}

const actions = {
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  setZoom({ commit }, zoom) {
    commit('SET_ZOOM', zoom)
  },
  // 设置当前是否处于 Electron 内
  setInElectron({ commit }, inElectron) {
    commit('SET_IN_ELECTRON', inElectron)
  },
  /**
   * 设置评测的松紧度
   * @param commit
   * @param measureRateScale
   */
  setMeasureRateScale({ commit }, measureRateScale) {
    commit('SET_MEASURE_RATE_SCALE', measureRateScale)
  },
  // 设置教材版本
  setBookMaterial({ commit }, bookMaterial) {
    commit('SET_BOOK_MATERIAL', bookMaterial)
  },
  setShowExportProgress({ commit }, bol) {
    commit('SET_SHOW_EXPORT_PROGRESS', bol)
  },
  setClassDeviceType({ commit }, uidType) {
    commit('SET_CLASS_DEVICE_TYPE', uidType)
  },
  setShowBrushVisible({ commit }, visible) {
    commit('SET_SHOW_BRUSH_VISIBLE', visible)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
